import routerOptions0 from "F:/webroot/diary.ilovearomagrace.com/node_modules/.pnpm/nuxt@3.15.2_@parcel+watcher@2.5.0_@types+node@22.10.10_db0@0.2.1_ioredis@5.4.2_magicast@0.3.5_qy5utlq67x3zkyabdp7nzs3lje/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}